import { Link } from '@remix-run/react';
import { PaywallElement } from '@shared/dream-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Text from '~/components/Text';

import type { Paywall } from '~/interfaces/paywall';
import type { Publication } from '~/interfaces/publication';
import type { Subscription } from '~/interfaces/subscriptions';

interface PremiumGatedContentProps {
  subscription?: Subscription;
  publication: Publication;
  paywall: Paywall;
}

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const PremiumGatedContent = ({ subscription, publication, paywall }: PremiumGatedContentProps) => {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');

  // Sets the url to direct to upgrade page with offer_id if included
  useEffect(() => {
    if (window) {
      try {
        const baseUrl = new URL(`${window.location.origin}/upgrade${window.location.search}`);

        if (paywall.offer_id) {
          baseUrl.searchParams.set('offer_id', paywall.offer_id);
        }
        setUrl(baseUrl.toString());
      } catch {
        setUrl(`${window.location.origin}/upgrade${window.location.search}`);
      }
    }
  }, []);

  return (
    <div className="mx-auto mb-16 max-w-xl space-y-4">
      <PaywallElement
        theme={paywall.theme}
        url={url}
        element={{
          type: 'paywall_break',
          attrs: {
            id: paywall.id,
            data: {
              title: paywall.title,
              description: paywall.description,
              cta_text: paywall.cta_text,
              benefits: paywall.benefits,
              subheader: paywall.subheader,
              image_url: paywall.image_url,
              style: paywall.style,
            },
          },
          content: [{ id: 'text', text: '' }],
        }}
      >
        {null}
      </PaywallElement>

      {!subscription && (
        <Text
          as="span"
          type="body"
          theme="content"
          size="xs"
          className="flex items-center justify-center text-center text-xs tracking-wide opacity-75 sm:text-lg"
        >
          {t('login.already_a_subscriber')}
          <Link to="/login" className="ml-1">
            <span className="text-wt-primary underline underline-offset-1">{t('shared.cta.sign_in')}</span>.
          </Link>
        </Text>
      )}
    </div>
  );
};

export default PremiumGatedContent;
